import { render, staticRenderFns } from "./ProjectInfo.vue?vue&type=template&id=3f6c621e&scoped=true"
import script from "./ProjectInfo.vue?vue&type=script&lang=ts"
export * from "./ProjectInfo.vue?vue&type=script&lang=ts"
import style0 from "./ProjectInfo.vue?vue&type=style&index=0&id=3f6c621e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6c621e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3f6c621e')) {
      api.createRecord('3f6c621e', component.options)
    } else {
      api.reload('3f6c621e', component.options)
    }
    module.hot.accept("./ProjectInfo.vue?vue&type=template&id=3f6c621e&scoped=true", function () {
      api.rerender('3f6c621e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/project/ProjectInfo.vue"
export default component.exports